import React, { useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import {
  Grid,
  Card,
  TextField,
  Button,
  Alert,
  Snackbar,
  Slide,
  CircularProgress,
  Backdrop,
  InputAdornment,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
} from "@mui/material";
import axios from "axios";
import {
  SpaceDashboard,
  Facebook,
  Instagram,
  Save,
  WhatsApp,
  YouTube,
  LinkedIn,
  Gesture,
} from "@mui/icons-material";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import TextAlign from "@tiptap/extension-text-align";
import { Bold, Italic, AlignLeft, AlignCenter, AlignRight } from "lucide-react";

import { cardBodyStyle } from "components/cardBodyStyle";
import { blackColor } from "components/material-dashboard-react";

const useStyles = makeStyles(cardBodyStyle);

// Barra de herramientas del editor
const Toolbar = ({ editor }) => {
  if (!editor) return null;

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        padding: "8px",
        background: "#f5f5f5",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      {/* Botón Negrita */}
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        style={{
          background: editor.isActive("bold") ? "#e0e0e0" : "transparent",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        <Bold size={18} />
      </button>

      {/* Botón Cursiva */}
      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        style={{
          background: editor.isActive("italic") ? "#e0e0e0" : "transparent",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        <Italic size={18} />
      </button>

      {/* Botones de alineación */}
      {/* Botón text a la izquierda */}
      <button
        onClick={() => editor.chain().focus().setTextAlign("left").run()}
        style={{
          background: editor.isActive({ textAlign: "left" })
            ? "#e0e0e0"
            : "transparent",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        <AlignLeft size={18} />
      </button>
      {/* Botón text al centro */}
      <button
        onClick={() => editor.chain().focus().setTextAlign("center").run()}
        style={{
          background: editor.isActive({ textAlign: "center" })
            ? "#e0e0e0"
            : "transparent",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        <AlignCenter size={18} />
      </button>
      {/* Botón text a la derecha */}
      <button
        onClick={() => editor.chain().focus().setTextAlign("right").run()}
        style={{
          background: editor.isActive({ textAlign: "right" })
            ? "#e0e0e0"
            : "transparent",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
      >
        <AlignRight size={18} />
      </button>
      {/* Botón Justificar */}
      {/*<button
        onClick={() => editor.chain().focus().setTextAlign("justify").run()}
        style={{
          background: editor.isActive({ textAlign: "justify" })
            ? "#e0e0e0"
            : "transparent",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "4px 8px",
          cursor: "pointer",
        }}
       // disabled={!editor.can().setTextAlign("justify")}
      >
        <AlignJustify size={18} />
      </button>*/}
    </div>
  );
};

const createEditorConfig = (content) => ({
  extensions: [
    StarterKit.configure({
      dropcursor: false,
      gapcursor: false,
    }),
    TextAlign.configure({
      types: ["heading", "paragraph"],
      alignments: ["left", "center", "right"],
      defaultAlignment: "left",
    }),
  ],
  content: content || "<p>​</p>", // Carácter de ancho cero
  editorProps: {
    handleKeyDown: (view, event) => {
      if (event.key === " ") {
        return false; // Permite comportamiento normal de la barra espaciadora
      }
    },
  },
});

const TextEditor0 = ({ content, onUpdate }) => {
  const editor = useEditor({
    ...createEditorConfig(content),
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onUpdate(html);
    },
  });

  // Efecto modificado para cargar contenido solo cuando realmente cambia
  React.useEffect(() => {
    if (!editor || content === undefined) return;

    // Compara el contenido actual con el nuevo para evitar actualizaciones innecesarias
    const currentContent = editor.getHTML();
    if (currentContent !== content) {
      editor.commands.setContent(content || "<p>​</p>");
    }
  }, [content]); // Eliminamos editor de las dependencias

  return (
    <div>
      <Toolbar editor={editor} />
      <div style={{ maxHeight: "250px", overflowY: "auto" }}>
        <EditorContent editor={editor} />
      </div>
    </div>
  );
};

const TextEditor1 = ({ content, onUpdate }) => {
  const editor = useEditor({
    ...createEditorConfig(content),
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onUpdate(html);
    },
  });

  // Efecto modificado para cargar contenido solo cuando realmente cambia
  React.useEffect(() => {
    if (!editor || content === undefined) return;

    // Compara el contenido actual con el nuevo para evitar actualizaciones innecesarias
    const currentContent = editor.getHTML();
    if (currentContent !== content) {
      editor.commands.setContent(content || "<p>​</p>");
    }
  }, [content]); // Eliminamos editor de las dependencias

  return (
    <div>
      <Toolbar editor={editor} />
      <div style={{ maxHeight: "250px", overflowY: "auto" }}>
        <EditorContent editor={editor} />
      </div>
    </div>
  );
};

export default function FooterAdmin(props) {
  const classes = useStyles();

  const [rows, setRows] = React.useState([]);
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [mensageSystem, setMensageSystem] = React.useState("");
  const [openAlert, setOpenAlert] = React.useState(false);
  const [errorAlert, setErrorAlert] = React.useState("");
  const [mensaje, setMensaje] = React.useState("");
  const [disabled, setDisabled] = React.useState(true);
  const [openLoader, setOpenLoader] = React.useState(false);

  // 1. Función para encontrar el objeto 'policy' en additional
  const getPolicyContent = () => {
    if (!rows.length || !rows[0].additional)
      return "<p>Empieza a escribir aquí...</p>";

    // Busca el objeto que contiene 'policy' en el array additional
    const policyObj = rows[0].additional.find(
      (item) => item.policy !== undefined
    );

    return policyObj?.policy || "<p>Empieza a escribir aquí...</p>";
  };

  const getTermsContent = () => {
    if (!rows.length || !rows[0].additional)
      return "<p>Empieza a escribir aquí...</p>";

    const termsObj = rows[0].additional.find(
      (item) => item.terms !== undefined
    );

    return termsObj?.terms || "<p>Empieza a escribir aquí...</p>";
  };

  // 2. Estado inicial del editor
  const [editorContent0, setEditorContent0] = React.useState(
    getPolicyContent()
  );
  const [editorContent1, setEditorContent1] = React.useState(getTermsContent());

  // 3. Efecto para actualizar el contenido cuando rows cambie
  React.useEffect(() => {
    setEditorContent0(getPolicyContent());
    setEditorContent1(getTermsContent());
  }, [rows]);

  const { urlServices, UserAuth } = React.useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchData();
  }, []);

  const fetchData = async () => {
    setOpenLoader(true);

    const valueData = {
      values: [9],
    };

    try {
      const response = await axios.post(
        `${urlServices}post-templates/sections`,
        valueData,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      const rowsNew = response.data.map((val) => {
        return {
          ...val,
          buttons: parseJsonArray(val.buttons),
          additional: parseJsonArray(val.additional),
          backgroundColor: JSON.parse(val.backgroundColor),
        };
      });

      console.log(rowsNew);

      setRows(rowsNew);
      setOpenLoader(false);
    } catch (error) {
      setOpenLoader(false);
      if (error.response && error.response.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);

        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else {
        setOpenLoader(false);
        setRows([]);
      }
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const updatePromises = rows.map((section) => {
        const dataValue = {
          textMain: section.textMain,
          textSecondary: section.textSecondary,
          backgroundColor: section.backgroundColor
            ? JSON.stringify(section.backgroundColor)
            : null,
          buttons: section.buttons ? JSON.stringify(section.buttons) : null,
          additional: section.additional
            ? JSON.stringify(section.additional)
            : null,
        };

        return axios.put(
          `${urlServices}post-templates/${section.id}`,
          dataValue,
          {
            headers: { Authorization: "Bearer " + keyAuthorization },
          }
        );
      });

      // 5. Ejecutamos las actualizaciones en el backend
      await Promise.all(updatePromises);

      fetchData();

      setOpenAlert(true);
      setErrorAlert("success");
      setMensaje("Cambios guardados con éxito");
    } catch (e) {
      if (e.response && e.response.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);

        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else {
        setMensaje("Error al guardar los cambios.");
        setOpenAlert(true);
        setErrorAlert("error");
      }
    } finally {
      setDisabled(true);
    }
  };

  const handleSelectSectionColor = (sectionId) => (event) => {
    const updatedSections = rows.map((section) => {
      if (section.id === sectionId) {
        // Tomar el objeto backgroundColor existente o crear uno nuevo si no existe
        const existingBackgroundColor = section.backgroundColor || {};

        // Crear un nuevo objeto con todas las propiedades existentes y actualizar background
        const updatedBackgroundColor = {
          ...existingBackgroundColor,
          background: event.target.value,
        };

        // Actualizar la sección manteniendo todas sus otras propiedades
        return {
          ...section,
          backgroundColor: updatedBackgroundColor,
        };
      }
      return section;
    });

    // Actualizar el estado con las secciones modificadas
    setRows(updatedSections);
    setDisabled(false);
  };

  const handleSelectSectionTextColor = (sectionId) => (event) => {
    const updatedSections = rows.map((section) => {
      if (section.id === sectionId) {
        // Tomar el objeto backgroundColor existente o crear uno nuevo si no existe
        const existingBackgroundColor = section.backgroundColor || {};

        // Crear un nuevo objeto con todas las propiedades existentes y actualizar background
        const updatedBackgroundColor = {
          ...existingBackgroundColor,
          color: event.target.value,
        };

        // Actualizar la sección manteniendo todas sus otras propiedades
        return {
          ...section,
          backgroundColor: updatedBackgroundColor,
        };
      }
      return section;
    });

    // Actualizar el estado con las secciones modificadas
    setRows(updatedSections);
    setDisabled(false);
  };

  const handleChange = (sectionId, field) => (event) => {
    const updatedSections = rows.map((section) => {
      // Encuentra la sección que corresponde al sectionId
      if (section.id === sectionId) {
        return {
          ...section,
          [field]: event.target.value, // Actualiza el campo específico
        };
      }
      return section; // Devuelve la sección sin cambios si no coincide
    });

    setRows(updatedSections);
    setDisabled(false);
  };

  const handleChangeButton = (sectionId, field) => (event) => {
    const updatedSections = rows.map((section) => {
      if (section.id === sectionId) {
        // Crear un nuevo array de botones
        const updatedButtons = section.buttons.map((button, index) => {
          // Determinar qué botón debemos actualizar basado en el índice
          if (field === "button1Text" && index === 0) {
            return { button1Text: event.target.value };
          } else if (field === "button2Text" && index === 1) {
            return { button2Text: event.target.value };
          } else if (field === "button3Text" && index === 2) {
            return { button3Text: event.target.value };
          } else if (field === "button4Text" && index === 3) {
            return { button4Text: event.target.value };
          } else if (field === "button5Text" && index === 4) {
            return { button5Text: event.target.value };
          } else if (field === "button6Text" && index === 5) {
            return { button6Text: event.target.value };
          }
          return button; // Mantener los otros botones sin cambios
        });

        return { ...section, buttons: updatedButtons };
      }
      return section;
    });

    setRows(updatedSections);
    setDisabled(false);
  };

  const handleChangeAdditional = (sectionId, field) => (event) => {
    const updatedSections = rows.map((section) => {
      if (section.id !== sectionId) return section; // Si no es la sección, retorna sin cambios

      // Si no existe `additional`, lo inicializamos como un array vacío
      const currentAdditional = section.additional || [];

      // Buscamos si ya existe un objeto con el campo que queremos modificar
      let foundField = false;
      const updatedAdditional = currentAdditional.map((item) => {
        if (field in item) {
          // Si el objeto tiene el campo (ej: "copyright")
          foundField = true;
          return { ...item, [field]: event.target.value }; // Actualiza el campo
        }
        return item; // Si no, lo deja igual
      });

      // Si no se encontró el campo, agregamos un nuevo objeto con ese campo
      if (!foundField) {
        updatedAdditional.push({ [field]: event.target.value });
      }

      // Retorna la sección actualizada
      return {
        ...section,
        additional: updatedAdditional,
      };
    });

    setRows(updatedSections);
    setDisabled(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  // Función para manejar actualizaciones del editor
  const handleEditorUpdate = (html, prop) => {
    if (prop === "terms") {
      setEditorContent1(html);
    } else {
      setEditorContent0(html);
    }

    setDisabled(false);

    const updatedSections = rows.map((section) => {
      if (section.id === rows[0].id) {
        const currentAdditional = section.additional || [];
        const updatedAdditional = currentAdditional.map((item) => {
          if (prop in item) {
            // Cambiado de [prop] in item a prop in item
            return { ...item, [prop]: html };
          }
          return item;
        });

        if (!currentAdditional.some((item) => prop in item)) {
          updatedAdditional.push({ [prop]: html });
        }

        return {
          ...section,
          additional: updatedAdditional,
        };
      }
      return section;
    });

    setRows(updatedSections);
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Grid container>
      <Grid item xs={12} sm={8} md={8}>
        {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
        <div className={classes.cardTitleBlack}>
          <SpaceDashboard className={classes.iconFilter} /> Plantilla pie de
          página
        </div>
      </Grid>
      <Grid item xs={12} sm={4} md={4}>
        <Button
          variant="contained"
          color="success"
          sx={{ float: "right" }}
          startIcon={<Save />}
          disabled={disabled}
          onClick={submitForm}
        >
          Guardar todos los cambios
        </Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Card
          sx={{ padding: "15px 20px", margin: "10px 0" }}
          variant="outlined"
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              sx={{ background: "#f6f6f6", p: 1, m: 2 }}
            >
              <b className={classes.cardTitleBlack} style={{ fontSize: 18 }}>
                Footer (Información)
              </b>
            </Grid>
            {rows.length > 0 && (
              <>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Título"
                    variant="outlined"
                    value={rows[0].textMain}
                    onChange={handleChange(rows[0].id, "textMain")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Párrafo"
                    variant="outlined"
                    value={rows[0].textSecondary}
                    onChange={handleChange(rows[0].id, "textSecondary")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <FormControl sx={{ minWidth: "100%" }}>
                    <InputLabel id="demo-simple-select-disabled-label">
                      Color del fondo
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-disabled-label"
                      id="demo-simple-select-disabled"
                      value={rows[0].backgroundColor.background}
                      label="Color del fondo"
                      onChange={handleSelectSectionColor(rows[0].id)}
                    >
                      <MenuItem value="#ffdab961">
                        <div
                          style={{
                            background: "#ffdab961",
                            padding: 10,
                            width: "100%",
                            border: "1px solid #f6f6f6",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="#ffffff">
                        <div
                          style={{
                            background: "#ffffff",
                            padding: 10,
                            width: "100%",
                            border: "1px solid #f6f6f6",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="gold">
                        <div
                          style={{
                            background: "gold",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="#FB9F55">
                        <div
                          style={{
                            background: "#FB9F55",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="Violet">
                        <div
                          style={{
                            background: "Violet",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="deepskyblue">
                        {" "}
                        <div
                          style={{
                            background: "deepskyblue",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="#d8f8e1">
                        {" "}
                        <div
                          style={{
                            background: "#d8f8e1",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="#000">
                        {" "}
                        <div
                          style={{
                            background: "#000",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <FormControl sx={{ minWidth: "100%" }}>
                    <InputLabel id="demo-simple-select-disabled-label">
                      Color del texto
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-disabled-label"
                      id="demo-simple-select-disabled"
                      value={rows[0].backgroundColor.color}
                      label="Color del texto"
                      onChange={handleSelectSectionTextColor(rows[0].id)}
                    >
                      <MenuItem value={blackColor}>
                        {" "}
                        <div
                          style={{
                            background: blackColor,
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="#000">
                        {" "}
                        <div
                          style={{
                            background: "#000",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="#ffffff">
                        <div
                          style={{
                            background: "#ffffff",
                            padding: 10,
                            width: "100%",
                            border: "1px solid #f6f6f6",
                          }}
                        ></div>
                      </MenuItem>
                      <MenuItem value="#FB9F55">
                        <div
                          style={{
                            background: "#FB9F55",
                            padding: 10,
                            width: "100%",
                          }}
                        ></div>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mt: 3 }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Redes sociales:
                  </b>
                  <Alert severity="info">
                    Ingrese los enlaces de sus redes sociales en los campos
                    correspondientes para que los iconos aparezcan
                    automáticamente.
                  </Alert>
                </Grid>
                <Grid item xs={12} sm={5} md={5}>
                  <TextField
                    label="Enlace de whatsapp"
                    variant="outlined"
                    value={rows[0].buttons[0].button1Text}
                    onChange={handleChangeButton(rows[0].id, "button1Text")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <WhatsApp sx={{ color: blackColor }} />
                        </InputAdornment>
                      ),
                    }}
                    helperText="Enlace para el pie de página y el boton flotante."
                  />
                </Grid>
                <Grid item xs={12} sm={3.5} md={3.5}>
                  <TextField
                    label="Enlace de instagram"
                    variant="outlined"
                    value={rows[0].buttons[1].button2Text}
                    onChange={handleChangeButton(rows[0].id, "button2Text")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Instagram sx={{ color: blackColor }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3.5} md={3.5}>
                  <TextField
                    label="Enlace de facebook"
                    variant="outlined"
                    value={rows[0].buttons[2].button3Text}
                    onChange={handleChangeButton(rows[0].id, "button3Text")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Facebook sx={{ color: blackColor }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextField
                    label="Canal de youtube"
                    variant="outlined"
                    value={rows[0].buttons[3].button4Text}
                    onChange={handleChangeButton(rows[0].id, "button4Text")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <YouTube sx={{ color: blackColor }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextField
                    label="Enlace de linkedin"
                    variant="outlined"
                    value={rows[0].buttons[4].button5Text}
                    onChange={handleChangeButton(rows[0].id, "button5Text")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkedIn sx={{ color: blackColor }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextField
                    label="Enlace de threads"
                    variant="outlined"
                    value={rows[0].buttons[5].button6Text}
                    onChange={handleChangeButton(rows[0].id, "button6Text")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Gesture sx={{ color: blackColor }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mt: 3 }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Políticas, terminos y condiciones:
                  </b>
                </Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mt: 1 }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, color: "#000" }}
                  >
                    Políticas:
                  </b>
                  <Card
                    sx={{
                      mt: 1,
                      "& .tiptap": {
                        minHeight: "200px",
                        padding: "10px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        "&:focus": {
                          outline: "none",
                          borderColor: "#1976d2",
                        },
                        "& p": {
                          color: "#000000 !important", // Asegura que todos los elementos sean negros
                          margin: "0 0 1rem 0",
                        },
                        "& ul, & ol": {
                          padding: "0 1rem",
                          margin: "1rem 0",
                        },
                        "& h1, & h2, & h3, & h4, & h5, & h6": {
                          color: "#000000 !important", // Asegura que todos los elementos sean negros
                          margin: "1rem 0",
                        },
                      },
                    }}
                  >
                    <TextEditor0
                      content={editorContent0}
                      onUpdate={(html) => handleEditorUpdate(html, "policy")}
                    />
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mt: 1 }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, color: "#000" }}
                  >
                    Terminos y condiciones:
                  </b>
                  <Card
                    sx={{
                      mt: 1,
                      "& .tiptap": {
                        minHeight: "200px",
                        padding: "10px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        "&:focus": {
                          outline: "none",
                          borderColor: "#1976d2",
                        },
                        "& p": {
                          color: "#000000 !important", // Asegura que todos los elementos sean negros
                          margin: "0 0 1rem 0",
                        },
                        "& ul, & ol": {
                          padding: "0 1rem",
                          margin: "1rem 0",
                        },
                        "& h1, & h2, & h3, & h4, & h5, & h6": {
                          color: "#000000 !important", // Asegura que todos los elementos sean negros
                          margin: "1rem 0",
                        },
                      },
                    }}
                  >
                    <TextEditor1
                      content={editorContent1}
                      onUpdate={(html) => handleEditorUpdate(html, "terms")}
                    />
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mt: 3 }}>
                  <b
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14, fontWeight: 500 }}
                  >
                    Copyright:
                  </b>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    label="Copyright"
                    variant="outlined"
                    value={rows[0].additional[0]?.copyright}
                    onChange={handleChangeAdditional(rows[0].id, "copyright")}
                    type="text"
                    autoComplete="off"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Card>
      </Grid>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity={errorAlert === "error" ? "error" : "success"}
            elevation={6}
            variant="filled"
          >
            {mensaje}
          </Alert>
        </Slide>
      </Snackbar>
    </Grid>
  );
}
